<template>
  <div class="p-5 flex flex-col items-center gap-y-2">
    <div class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6">
      <slot></slot>
    </div>
    <RoomCBTInfoItem v-for="(user, i) in users" :key="i" :user="user" />
  </div>
</template>

<script>
import RoomCBTInfoItem from "@/components/Room/CBT/RoomCBTInfoItem.vue";

export default {
  name: 'RoomCbtInfoForm',
  components: {
    RoomCBTInfoItem
  },
  props: {
    users: { type: Array, default: () => ([]) },
  },
}
</script>